import React from "react";
import { FiSearch } from "react-icons/fi";

interface NoContentMessageProps {
  message: string;
}

function NoContentMessage({ message }: NoContentMessageProps) {
  return (
    <div style={{ textAlign: "center", padding: "4rem 1.5rem" }}>
      <div style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 72,
        height: 72,
        borderRadius: "50%",
        background: "#f8fafc",
        border: "1.5px solid #f0f4f8",
        marginBottom: "1.25rem",
      }}>
        <FiSearch size={28} color="#cbd5e1" />
      </div>
      <h5 style={{ color: "#1e293b", fontWeight: 700, marginBottom: "0.5rem", fontSize: "1.0625rem" }}>
        No results found
      </h5>
      <p style={{ color: "#94a3b8", fontSize: "0.9rem", maxWidth: 280, margin: "0 auto" }}>
        Try adjusting your search or filters to find what you're looking for.
      </p>
    </div>
  );
}

export default NoContentMessage;
